import { Box, styled } from '@mui/material';

const StyledDrawerMenuLogoContainer = styled(Box)(({ theme }) => ({
  // Logo colapsado centrado y a tamaño contenido (no a ancho completo).
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(2, 0, 1),
  '& svg': {
    height: 40,
    width: 'auto'
  }
}));

export default StyledDrawerMenuLogoContainer;
